module.exports = __webpack_public_path__ + "static/media/7ICJ2.76976c36.jpg";